'use client';

import { emptyField, useContactForm } from '../useContactForm';

export const useFieldState = (fieldName: string) => {
	const [formState] = useContactForm();

	return formState?.fields[fieldName] || emptyField;
};
